var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWowIconTank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#6B90DC",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.522 5.884L12 4.667l5.478 1.217a.667.667 0 01.522.65v6.659a4 4 0 01-1.781 3.328L12 19.333l-4.219-2.812A4 4 0 016 13.193V6.535c0-.313.217-.583.522-.65z",
    fill: "#3473F5"
  })));
}
export default __webpack_public_path__ + "static/svg/wow-icon-tank.svg";
export { SvgWowIconTank as ReactComponent };